document.addEventListener('DOMContentLoaded', function () {
  // Click interception to prevent theme AJAX on same-page hash links
  document.addEventListener('click', function (e) {
    const link = e.target.closest('a');
    if (!link) return;

    const href = link.getAttribute('href') || '';
    if (href.includes('#')) {
      const [path, hash] = href.split('#');

      // Same page link
      if (path === '' || window.location.pathname.replace(/\/+$/, '') === path.replace(/\/+$/, '')) {
        e.stopImmediatePropagation(); // Stop theme's AJAX handler
        e.preventDefault();

        const target = document.getElementById(hash);
        if (target) {
          target.scrollIntoView({ behavior: 'smooth' });
        }
      }
    }
  }, true); // capture mode to run before theme handler

  // If page loads with hash (from external link)
  if (window.location.hash) {
    const target = document.querySelector(window.location.hash);
    if (target) {
      setTimeout(() => {
        target.scrollIntoView({ behavior: 'smooth' });
      }, 200);
    }
  }
});
